<template>
  <!-- Error State -->
  <div
    v-if="error"
    class="error-state"
  >
    <p>{{ error }}</p>
  </div>

  <!-- Brands Grid -->
  <ul
    v-if="!loading && !error && brands.length > 0"
    class="brands-grid__list"
  >
    <li
      v-for="brand in brands"
      :key="brand.brand_id"
      class="brands-grid__list__item"
    >
      <a
        :href="`/searchbrand?querybrand=${brand.brand_id}&name=${
          encodeURIComponent(brand.name)
        }`"
        :title="brand.name"
        class="brands-grid__list__item__link"
      >
        <img
          :src="brand.image_path"
          :alt="brand.name"
        >
      </a>
    </li>
  </ul>

  <!-- No Brands Available -->
  <div
    v-if="!loading && !error && brands.length === 0"
    class="no-brands"
  >
    <p>No brands available</p>
  </div>
</template>

<script>
export default {
  name: 'BrandsGridModule',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      brands: [],
      loading: false,
      error: null,
    };
  },

  mounted() {
    if (this.data.brands_id) {
      this.fetchBrands();
    }
  },

  methods: {
    fetchBrands() {
      if (!this.data.brands_id) return;

      this.loading = true;
      this.error = null;

      $.ajax({
        type: 'post',
        url: '/ajax/merchandising',
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        data: {
          groupBrandMerchandising_ids: [this.data.brands_id],
        },
        timeout: 30000,
        success: (response) => {
          this.loading = false;
          this.brands = response.data?.brandmerchandising?.[this.data.brands_id] || [];
        },
        error: (xhr, status, error) => {
          this.loading = false;
          this.error = `Error loading brands: ${status} - ${error}`;
          this.brands = [];
        },
      });
    },
  },
};
</script>
